<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        :class="{
          'ml-2': !$vuetify.breakpoint.mobile
        }"
        v-on="on"
        v-bind="attrs"
        small
        outlined
        color="red"
      >
        {{ $t("emailVerification.button") }}
      </v-btn>
    </template>
    <v-card>
      <v-toolbar dense>
        {{ $t("emailVerification.dialogTitle") }}
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="mt-4">
        <v-alert
          border="left"
          max-width="600"
          colored-border
          type="info"
          color="#B50000"
          elevation="2"
        >
          <span style="font-size: 0.8em;">
            {{
              emailNeededForWithdraws
                ? `${$t("emailVerification.description")}
                  ${$t("emailVerification.areYouSure")}`
                : $t("emailVerification.areYouSure")
            }}
          </span>
        </v-alert>
      </v-card-text>

      <v-card-actions class="px-10 pb-8">
        <v-row no-gutters>
          <v-col
            :cols="$vuetify.breakpoint.xs ? '12' : ''"
            :class="
              $vuetify.breakpoint.xs
                ? 'd-flex flex-column-reverse'
                : 'd-flex justify-center'
            "
          >
            <v-btn
              outlined
              color="white"
              :block="$vuetify.breakpoint.xs"
              small
              :disabled="loading"
              @click.prevent="dialog = false"
            >
              {{ $t("cancel") }}
            </v-btn>

            <v-btn
              :class="$vuetify.breakpoint.xs ? 'ml-0 mb-6' : 'px-9 ml-4'"
              :block="$vuetify.breakpoint.xs"
              small
              color="#B50000"
              type="submit"
              @click.prevent="verifyPlayerEmail"
              :loading="loading"
              :disabled="loading"
            >
              {{ $t("yes") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["user_id"],

  data: () => ({
    dialog: false,
    loading: false,
    validForm: false,
  }),

  computed: {
    emailNeededForWithdraws() {
      return (
        this.$store.state.operator &&
        this.$store.state.operator.email_validation == "1"
      );
    },
  },

  methods: {
    verifyPlayerEmail() {
      this.loading = true;

      this.$axios
        .post(
          `${this.$prefix()}/players/manualEmailVerification`,
          this.$formdata({ user_id: this.user_id })
        )
        .then((res) => {
          this.$store.commit("setFeedbackSnack", {
            msg: res.data.messages,
            color: "success",
          });

          this.$emit("getPlayer");

          this.dialog = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
